import { FullScreenModals } from '../Widget/old/full-screen-modals/full-screen-modals';
import { waitForWixSdkLoaded } from '../Widget/old/containers/waitForWixSdkLoaded';

export default waitForWixSdkLoaded(FullScreenModals);
